// @core/api/endpoints/workflow/update_pipeline_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelinePolicyResponse,
  UpdatePipelinePolicyRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Update pipeline policy
 * Updates an existing pipeline policy.
 */
export async function UpdatePipelinePolicy(
  policy_id: string,
  data: UpdatePipelinePolicyRequest,
  options?: RequestOptions
): Promise<PipelinePolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/pipeline-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.put<PipelinePolicyResponse>(requestPath, data, requestOptions);
}
